function updateHeaderHeight(element) {
            if (!element) {
                console.error('Element is required');
                return;
            }
            const height = element.offsetHeight;
            document.documentElement.style.setProperty('--header-height', `${height}px`);
        }

        function onResize() {
            const headerElement = document.querySelector('header-group');
            updateHeaderHeight(headerElement);
        }

        document.addEventListener('DOMContentLoaded', () => {
            onResize(); // Update height on initial load
        });

        window.addEventListener('resize', () => {
            onResize();
        });



          function updateNewHeight(element, cssVariableName) {
            if (!element || !cssVariableName) return;
        
           
            let totalHeight = 0;
        

            let sibling = element.previousElementSibling;
            while (sibling) {
                totalHeight += sibling.offsetHeight;
                sibling = sibling.previousElementSibling;
            }
        

            const newHeight = totalHeight + 16;
        
            document.documentElement.style.setProperty(cssVariableName, `-${newHeight}px`);
            console.log("new height for", cssVariableName, ":", newHeight);
        }

        // Attach hover event listener to each .navmenu-item
        document.querySelectorAll('.navmenu-depth-2 .navmenu-item').forEach(item => {
            item.addEventListener('mouseover', () => {
                updateNewHeight(item , '--new-height');
            });   
        });

        document.querySelectorAll('.navmenu-depth-3 .navmenu-item').forEach(item => {
            item.addEventListener('mouseover', () => {
                updateNewHeight(item ,'--new-height-2');
                 
            });   
        });